/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cohere.integration.rpc.AppSettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type AppInstallRequest = { apiKey: string };

export type AppInstallResponse = { responseField: string };

export type ApiKeyUpdateRequest = { apiKey: string };

export type ApiKeyUpdateResponse = {};

export type CohereAppError = {
  chirpErrorMessage: Default<string>;
  type: ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'INVALID_API_KEY' | unhandledEnumCase;

export type InstallRequestType = Requestify<AppInstallRequest>;
export type InstallResponseType = AppInstallResponse;
export type InstallErrorType = CohereAppError & HubspotMetadata;
export const installRpc: ChirpAvroRpcDetails<
  InstallRequestType,
  InstallResponseType,
  InstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.cohere.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'sgaVyjFUsGD0ilHKLdpI9QAELmCErMr5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpsertApiKeyRequestType = Requestify<ApiKeyUpdateRequest>;
export type UpsertApiKeyResponseType = ApiKeyUpdateResponse;
export type UpsertApiKeyErrorType = CohereAppError & HubspotMetadata;
export const upsertApiKeyRpc: ChirpAvroRpcDetails<
  UpsertApiKeyRequestType,
  UpsertApiKeyResponseType,
  UpsertApiKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.cohere.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: '5Argc0QLeS7lD42UzcSlRgAELmCErMr5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
